module.exports = __webpack_public_path__ + "static/media/worker4.3ed53031.jpg";